module.exports = __webpack_public_path__ + "img/tree.9676b0e0.svg";